import React from "react"
import "./frames.css" // Asegúrate de que este path sea correcto

const Sigma36 = () => {
  return (
    <div className="frames-container">
      <h1 className="frames-title">
        Modelo Sigma 36: El Equilibrio Perfecto entre Coste y Confort
      </h1>

      <h2 className="frames-subtitle">Líder en Confort y Espacio</h2>
      <p className="frames-text">
        Durante más de 20 años, Perry Baromedical ha sido el líder indiscutible
        en la fabricación de cámaras hiperbáricas monoplaza de gran tamaño. Con
        la introducción de la SIGMA 36, Perry reafirma su posición al ofrecer no
        solo la SIGMA 40, sino también dos de las cámaras hiperbáricas monoplaza
        más grandes del mercado.
      </p>

      <h2 className="frames-subtitle">Confort Directo para el Paciente</h2>
      <p className="frames-text">
        Un tamaño más grande directamente se traduce en un mayor confort para el
        paciente. Este diseño tiene como objetivo mitigar cualquier sensación de
        ansiedad o confinamiento que el paciente pueda sentir durante el
        tratamiento.
      </p>

      <h2 className="frames-subtitle">Espacio y Comodidad</h2>
      <p className="frames-text">
        La SIGMA 36 tiene un diámetro interno de 91 cm, proporcionando un
        espacio amplio donde incluso los pacientes de gran tallaje se sentirán
        cómodos. El ángulo de inclinación de la camilla puede ajustarse hasta
        casi 60 grados, ofreciendo una posición cómoda incluso para aquellos que
        no toleran la posición supina.
      </p>

      <h2 className="frames-subtitle">Flexibilidad en Tratamiento</h2>
      <p className="frames-text">
        Al igual que la SIGMA 40, la SIGMA 36 puede acomodar pacientes con un
        peso de hasta 300 kg y una altura de hasta 1,95 m, lo que la convierte
        en una opción versátil para una amplia gama de necesidades de
        tratamiento.
      </p>

      <p className="frames-text">
        Esta combinación de comodidad, espacio y flexibilidad hace de la SIGMA
        36 una opción excepcional para aquellos que buscan un tratamiento
        hiperbárico de alta calidad a un coste más accesible.
      </p>
    </div>
  )
}

export default Sigma36
